import { useGoogleLogin } from '@react-oauth/google';
import { Icon } from 'common/icon';
import { Button } from 'common/new-button';
import { Analytics } from 'constants/analytics';

export const GoogleButton = ({
  className,
  onSuccess,
}: {
  className?: string;
  onSuccess: (token: string) => void;
}) => {
  const handle = useGoogleLogin({
    onSuccess: (tokenResponse) => onSuccess(tokenResponse?.access_token ?? ''),
  });

  return (
    <Button
      id={Analytics.user.editLinkGoogle}
      variant="secondary"
      className={className}
      icon={<Icon.Google />}
      onClick={() => handle()}
      text={'Link Google'}
    />
  );
};
